import React from 'react';
import _ from 'lodash';
import { Modal } from 'react-bootstrap';
import { ButtonVariant, TextButton } from '@/hybrid/core/TextButton.atom';
import { useTranslation } from 'react-i18next';

interface ConfirmDeleteModalProps {
  onClose: () => void;
  action: () => void;
  actionBtnLabel?: string;
  headerTranslationKey?: string;
  bodyTranslationKey?: string;
  confirmBtnVariant?: ButtonVariant;
}

/**
 * Modal dialog with Cancel/Delete buttons and configurable text/actions
 */
export const ConfirmDeleteModal: React.FunctionComponent<ConfirmDeleteModalProps> = (props) => {
  const {
    onClose,
    action,
    headerTranslationKey = '',
    bodyTranslationKey = '',
    actionBtnLabel = '',
    confirmBtnVariant = 'danger',
  } = props;
  const { t } = useTranslation();

  return (
    <Modal show={true} onHide={onClose} animation={false} data-testid="confirmDeleteModal">
      <Modal.Header closeButton={true}>
        <h4>{t(_.isEmpty(headerTranslationKey) ? 'DELETE_MODAL.HEADER' : headerTranslationKey)}</h4>
      </Modal.Header>
      <Modal.Body>
        <div className="semi-bold">{t(_.isEmpty(bodyTranslationKey) ? 'DELETE_MODAL.BODY' : bodyTranslationKey)}</div>
        <div className="flexColumnContainer flexFill flexJustifyEnd mt25">
          <TextButton
            onClick={() => {
              action();
              onClose();
            }}
            label={_.isEmpty(actionBtnLabel) ? 'DELETE' : actionBtnLabel}
            size="sm"
            testId="confirmDeleteBtn"
            extraClassNames="min-width 100 width-100 max-width-100 mr20"
            id="confirmDeleteBtn"
            variant={confirmBtnVariant}
          />

          <TextButton
            onClick={onClose}
            label="CANCEL"
            size="sm"
            testId="cancelDeleteBtn"
            extraClassNames="min-width 100 width-100 max-width-100"
            id="cancelDeleteBtn"
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};
